<template>
  <v-bottom-sheet v-model="sheet" inset v-if="role == 'admin'">
    <template v-slot:activator="{ on }">
      <v-fab-transition>
        <v-btn color="primary" fixed fab small dark bottom right v-on="on">
          <v-icon>mdi-reload</v-icon>
        </v-btn>
      </v-fab-transition>
    </template>
    <v-sheet class="text-center">
      <template v-if="mostrarAdmin">
        <span v-if="mostrarAdmin" class="display-2 mx-5"
          >SINCRONIZACIÓN ADMIN</span
        >
        <v-row>
          <v-col cols="3" v-for="(l, i) in cargasArrayAdmin" :key="i">
            <v-row align="center" justify="center">
              <v-col cols="4">
                <span class="subtitle-1">{{ l.nombre }}</span>
              </v-col>
              <v-col cols="1">
                <v-btn text @click="cargaParcial(l)">
                  <v-icon>mdi-reload</v-icon>
                </v-btn>
              </v-col>
              <v-spacer />
              <v-col cols="6">
                <v-progress-linear
                  v-if="l.loading"
                  :indeterminate="l.loading"
                  color="green"
                ></v-progress-linear>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </template>
      <template v-if="mostrarNegocio">
        <span class="display-2 mx-5">SINCRONIZACIÓN NEGOCIO</span>
        <v-row>
          <v-col cols="3" v-for="(l, i) in cargasArrayNegocio" :key="i">
            <v-row align="center" justify="center">
              <v-col cols="4">
                <span class="subtitle-1">{{ l.nombre }}</span>
              </v-col>
              <v-col cols="1">
                <v-btn text @click="cargaParcial(l)">
                  <v-icon>mdi-reload</v-icon>
                </v-btn>
              </v-col>
              <v-spacer />
              <v-col cols="6">
                <v-progress-linear
                  v-if="l.loading"
                  :indeterminate="l.loading"
                  color="green"
                ></v-progress-linear>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </template>
      <div class="my-3">Cargar de servidor</div>
    </v-sheet>
  </v-bottom-sheet>
</template>

<script>
import { mapState, mapGetters } from "vuex";
export default {
  data() {
    return {
      fab: false,
      sheet: false,
    };
  },
  computed: {
    ...mapState({
      cargasArrayAdmin: (state) => state.loading.cargasArrayAdmin,
      cargasArrayNegocio: (state) => state.loading.cargasArrayNegocio,
    }),
    ...mapGetters({
      role: "auth/role",
    }),
    mostrarAdmin() {
      return this.role == "admin";
    },
    mostrarNegocio() {
      return (
        this.$store.state.app.negocioGest != null &&
        (this.role == "admin" || this.role == "own")
      );
    },
  },
  methods: {
    cargaParcial(l) {
      l.loading = true;
      this.$store.dispatch(l.accion).finally(() => {
        l.loading = false;
      });
    },
  },
};
</script>

<style>
</style>